//
//
//
//
//
//
//

export default {
	name: 'Error',
	props: ["tag"]
}
